"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortableTBody = exports.SortableList = exports.SortableItem = exports.DragHandle = exports.DraggableContainer = void 0;
var aon_tws_common_ui_1 = require("@aon/aon-tws-common-ui");
var array_move_1 = __importDefault(require("array-move"));
var React = __importStar(require("react"));
var react_sortable_hoc_1 = require("react-sortable-hoc");
var styled_components_1 = __importStar(require("styled-components"));
var FormattedTable_1 = require("./FormattedTable");
var IndexBox_1 = require("./IndexBox");
var HandleCol = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t.draggable-handle {\n\t\tcursor: move; /* fallback if grab cursor is unsupported */\n\t\tcursor: -webkit-grab;\n\t\tcursor: -moz-grab;\n\t\tcursor: grab;\n\t}\n\n\tposition: absolute;\n\ttop: 7px;\n\tleft: 0;\n\n\t.draggable-handle :active {\n\t\tcursor: move; /* fallback if grabbing cursor is unsupported */\n\t\tcursor: -webkit-grabbing;\n\t\tcursor: -moz-grabbing;\n\t\tcursor: grabbing;\n\t}\n\n\t@media (max-width: 795px) {\n\t\tdisplay: none;\n\t}\n"], ["\n\t.draggable-handle {\n\t\tcursor: move; /* fallback if grab cursor is unsupported */\n\t\tcursor: -webkit-grab;\n\t\tcursor: -moz-grab;\n\t\tcursor: grab;\n\t}\n\n\tposition: absolute;\n\ttop: 7px;\n\tleft: 0;\n\n\t.draggable-handle :active {\n\t\tcursor: move; /* fallback if grabbing cursor is unsupported */\n\t\tcursor: -webkit-grabbing;\n\t\tcursor: -moz-grabbing;\n\t\tcursor: grabbing;\n\t}\n\n\t@media (max-width: 795px) {\n\t\tdisplay: none;\n\t}\n"])));
var BoxContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0px;\n\tright: 55px;\n\tmin-width: 18px;\n"], ["\n\tposition: absolute;\n\ttop: 0px;\n\tright: 55px;\n\tmin-width: 18px;\n"])));
var GlobalStyle = (0, styled_components_1.createGlobalStyle)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t.sortableHelper {\n\t\tz-index: 1050;\n\t}\n"], ["\n\t.sortableHelper {\n\t\tz-index: 1050;\n\t}\n"])));
exports.DraggableContainer = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tbackground-color: #444444;\n\tborder-radius: 3px 0 0 3px;\n\t", "\n\ttext-align: center;\n\twidth: 18px;\n\t.tws-i-icon {\n\t\tbottom: 1px;\n\t\tcolor: #fff;\n\t\tposition: relative;\n\t\tvertical-align: middle;\n\t}\n"], ["\n\tbackground-color: #444444;\n\tborder-radius: 3px 0 0 3px;\n\t", "\n\ttext-align: center;\n\twidth: 18px;\n\t.tws-i-icon {\n\t\tbottom: 1px;\n\t\tcolor: #fff;\n\t\tposition: relative;\n\t\tvertical-align: middle;\n\t}\n"])), function (props) {
    return props.needAbsolutePosition
        ? "\n\t\tposition: absolute;\n\t\tright: 2px;\n\t\ttop: 0px;"
        : "position: relative;\n\t\tright: 20px;";
});
exports.DragHandle = (0, react_sortable_hoc_1.SortableHandle)(function (props) { return (React.createElement(exports.DraggableContainer, { id: 'draggableIcon', className: 'draggable-handle', needAbsolutePosition: props.needAbsolutePosition },
    React.createElement(aon_tws_common_ui_1.Icon, { name: 'move' }))); });
exports.SortableItem = (0, react_sortable_hoc_1.SortableElement)(function (props) {
    return (React.createElement(FormattedTable_1.FormattedTableRow, { id: props.id, hideLeftBorder: props.hideLeftBorder, className: props.className },
        props.children,
        React.createElement(HandleCol, null,
            props.needBox !== undefined && (React.createElement(BoxContainer, { id: 'indexBox' },
                React.createElement(IndexBox_1.IndexBox, { index: props.sequence || 0 }))),
            React.createElement(exports.DragHandle, { needAbsolutePosition: props.needAbsolutePosition }))));
});
exports.SortableList = (0, react_sortable_hoc_1.SortableContainer)(function (props) {
    return (React.createElement(FormattedTable_1.FormattedTBodyContainer, { isDisabled: props.disabled },
        React.createElement("div", null, props.children)));
});
var SortableTBody = /** @class */ (function (_super) {
    __extends(SortableTBody, _super);
    function SortableTBody(props) {
        var _this = _super.call(this, props) || this;
        _this.onSortEnd = function (_a) {
            var oldIndex = _a.oldIndex, newIndex = _a.newIndex;
            if (!_this.props.disabled) {
                var items = (0, array_move_1.default)(_this.props.items, oldIndex, newIndex);
                var primaryKey_1 = _this.props.primaryKey !== undefined ? _this.props.primaryKey : 'id';
                _this.props.onChange(items.map(function (item) { return item[primaryKey_1]; }));
            }
        };
        return _this;
    }
    SortableTBody.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(GlobalStyle, null),
            React.createElement(exports.SortableList, { useDragHandle: true, disabled: this.props.disabled, onSortEnd: this.onSortEnd, lockAxis: 'y', helperClass: 'sortableHelper' }, this.props.children)));
    };
    return SortableTBody;
}(React.Component));
exports.SortableTBody = SortableTBody;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
